var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mapGetters } from "vuex";
import Stream from "./Stream";
import VideoDeviceSelect from "./VideoDeviceSelect";
import AudioDeviceSelect from "./AudioDeviceSelect";
import OptionsMenuSelect from "./OptionsMenuSelect";
import ScreenMenuSelect from "./ScreenMenuSelect";
export default {
    name: "local",
    components: {
        Stream: Stream,
        VideoDeviceSelect: VideoDeviceSelect,
        AudioDeviceSelect: AudioDeviceSelect,
        OptionsMenuSelect: OptionsMenuSelect,
        ScreenMenuSelect: ScreenMenuSelect,
    },
    data: function () {
        return {
            localPeerId: "",
            dropdownVisible: false,
            screenDropdownVisible: false,
        };
    },
    computed: __assign(__assign({}, mapGetters(["supportScreensharing", "sharingScreenAndVideo", "sharingScreenOnly"])), { sourceStream: function () {
            return this.$store.getters.localStream;
        },
        isError: function () {
            return !!this.$store.getters.fatalError;
        },
        isConnected: function () {
            return !this.isError && this.$store.getters.appState === "connected";
        } }),
    methods: {
        toggleDropdown: function () {
            this.dropdownVisible = !this.dropdownVisible;
        },
        toggleScreenDropdown: function () {
            this.screenDropdownVisible = !this.screenDropdownVisible;
        },
    },
    created: function () {
        var _this = this;
        this.$socket.whenReady().then(function (_a) {
            var session = _a.session;
            _this.localPeerId = session.peerGuid;
        });
        document.addEventListener("click", function (event) {
            if (event.target.matches("[data-settings-dropdown]"))
                return;
            _this.dropdownVisible = false;
        });
        document.addEventListener("click", function (event) {
            if (event.target.matches("[data-screen-dropdown]"))
                return;
            _this.screenDropdownVisible = false;
        });
    },
};



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Local.vue
// module id = 328
// module chunks = 1